import DemandaRepository from "../repository/demanda_repository";

class DemandaService {
	constructor() {
		this.repository = new DemandaRepository();
	}

	async save(data) {
		return this.repository.save(data);
	}

	async update(data) {
		return this.repository.update(data);
	}

	async getDemandasPorData(unidadeDistribuidoraId, data, page = 1, limit = 50) {
		return this.repository.getDemandasPorData(unidadeDistribuidoraId, data, page, limit);
	}

	async getCobertura(unidadeDistribuidoraId, data) {
		return this.repository.getCobertura(unidadeDistribuidoraId, data);
	}

	async getById(id) {
		return this.repository.getById(id);
	}

	async changeVisibility(id) {
		return this.repository.changeVisibility(id);
	}
}

export default DemandaService;
